import { gql } from '@apollo/client';

export const GET_VIEWER_INFO = gql`
  query MyQuery {
    fetchSpotLightEvents {
      openSpotLightEvents {
        id
        heroPlayList {
          assets {
            assetId
            basename
            hlsPlaylistUrl
            description
            mimeType
            mp4Url
            thumbnailUrl
            type
            url
            webmUrl
          }
        }
        summary
        slug
      }
    }
  }
`;
